import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ActivityItem, CreateNoteInput, Paginated } from '@crm/shared';
import { api } from '../../api/client';

export interface ActivityParams {
  contactId?: string;
  organizationId?: string;
  dealId?: string;
  types?: string[];
  page?: number;
  pageSize?: number;
}

export function useActivities(params: ActivityParams) {
  return useQuery({
    queryKey: ['activities', params],
    queryFn: async () =>
      (
        await api.get<Paginated<ActivityItem>>('/activities', {
          params: { ...params, types: params.types?.join(',') || undefined },
        })
      ).data,
    enabled: !!(params.contactId || params.organizationId || params.dealId),
  });
}

export function useAddNote() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: CreateNoteInput) => (await api.post<ActivityItem>('/activities', input)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['activities'] }),
  });
}

export function useDeleteNote() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => (await api.delete(`/activities/${id}`)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['activities'] }),
  });
}
